<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center" style="line-height: 2em;"><strong><span class="big1">WELCOME TO THE</span></strong></p>
<p class="center"><img alt="" src="OEBPS/images/tp_everuthing.jpg"/></p>
<p class="center"><strong><span class="big2">PARENT’S GUIDE TO</span></strong></p>
<p class="extract">Everything<sup>®</sup> Parent’s Guides are a part of the bestselling Everything<sup>®</sup> series and cover common parenting issues like childhood illnesses and tantrums, as well as medical conditions like asthma and juvenile diabetes. These family-friendly books are designed to be a one-stop guide for parents. If you want authoritative information on specific topics not fully covered in other books, Everything<sup>®</sup> Parent’s Guides are your perfect solution.</p>
<p class="center"><img alt="" src="OEBPS/images/alert.png"/></p>
<p class="center">Urgent warnings</p>
<p class="center"><img alt="" src="OEBPS/images/essen.png"/></p>
<p class="center">Quick handy tips</p>
<p class="center"><img alt="" src="OEBPS/images/fact.png"/></p>
<p class="center">Important snippets of information</p>
<p class="center"><img alt="" src="OEBPS/images/que.png"/></p>
<p class="center">Answers to common questions</p>
<p class="extract">When you’re done reading, you can finally say you know <strong>EVERYTHING</strong><sup>®</sup>!<br/><br/></p>
<p class="center"><strong><span class="small">PUBLISHER</span></strong> Karen Cooper</p>
<p class="center"><strong><span class="small">DIRECTOR OF ACQUISITIONS AND INNOVATION</span></strong> Paula Munier</p>
<p class="center"><strong><span class="small">MANAGING EDITOR, EVERYTHING<sup>®</sup> SERIES</span></strong> Lisa Laing</p>
<p class="center"><strong><span class="small">COPY CHIEF</span></strong> Casey Ebert</p>
<p class="center"><strong><span class="small">ASSISTANT PRODUCTION EDITOR</span></strong> Melanie Cordova</p>
<p class="center"><strong><span class="small">ACQUISITIONS EDITOR</span></strong> Brett Palana-Shanahan</p>
<p class="center"><strong><span class="small">SENIOR DEVELOPMENT EDITOR</span></strong> Brett Palana-Shanahan</p>
<p class="center"><strong><span class="small">EDITORIAL ASSISTANT</span></strong> Ross Weisman</p>
<p class="center"><strong><span class="small">EVERYTHING<sup>®</sup> SERIES COVER DESIGNER</span></strong> Erin Alexander</p>
<p class="center"><strong><span class="small">LAYOUT DESIGNERS</span></strong> Erin Dawson, Michelle Roy Kelly, <br/>Elisabeth Lariviere, Denise Wallace</p>
<div class="box">
<p class="center">Visit the entire Everything<sup>®</sup> series at <em><a class="hlink" href="http://www.everything.com" target="_blank">www.everything.com</a></em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm1.vue?57e3d673